// Estado do formulário de despesa e as contas que o resumo ao lado mostra.

export const hojeLocal = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const VAZIO = {
  name: "", classificationId: "", supplier: "", value: "", dueDate: hojeLocal(), isPaid: false, notes: "",
  isRecurring: false, recurringPeriod: "monthly", recurringCount: "12", installments: "", modulos: [],
};

export function deDespesa(e) {
  return {
    name: e.name || "", classificationId: e.classification_id || "", supplier: e.supplier || "",
    value: e.value != null ? String(e.value) : "", dueDate: e.due_date || hojeLocal(), isPaid: !!e.is_paid,
    notes: e.notes || "", isRecurring: !!e.is_recurring, recurringPeriod: e.recurring_period || "monthly",
    recurringCount: "12", installments: e.installments_total ? String(e.installments_total) : "", modulos: e.modulos || [],
  };
}

// Mesma validação e mesmo corpo que o popup antigo enviava, mais `modulos`.
export function validar(f) {
  if (!f.name.trim()) return "Informe o nome da despesa";
  if (!f.value || parseFloat(f.value) <= 0) return "Informe um valor válido";
  if (!f.dueDate) return "Informe a data de vencimento";
  if (f.isRecurring && (!f.recurringCount || parseInt(f.recurringCount, 10) < 1)) return "Informe quantas vezes a despesa vai se repetir";
  return null;
}

export function paraApi(f) {
  return {
    name: f.name,
    classification_id: f.classificationId || null,
    supplier: f.supplier || null,
    value: parseFloat(f.value),
    due_date: f.dueDate,
    is_paid: f.isPaid,
    // Conhecido (ver ficha): marcar como paga grava HOJE como data de pagamento.
    paid_date: f.isPaid ? hojeLocal() : null,
    is_recurring: f.isRecurring,
    recurring_period: f.isRecurring ? f.recurringPeriod : null,
    recurring_count: f.isRecurring ? parseInt(f.recurringCount, 10) : null,
    installments_total: f.installments ? parseInt(f.installments, 10) : 0,
    notes: f.notes || null,
    modulos: f.modulos,
  };
}

const somar = (iso, { meses = 0, dias = 0, anos = 0 }) => {
  const [a, m, d] = iso.split("-").map(Number);
  // Dia que não existe no mês (31) vai para o último dia — como o servidor faz.
  const alvo = new Date(a + anos, m - 1 + meses, 1);
  const ultimo = new Date(alvo.getFullYear(), alvo.getMonth() + 1, 0).getDate();
  const data = new Date(alvo.getFullYear(), alvo.getMonth(), Math.min(d, ultimo) + dias);
  return `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, "0")}-${String(data.getDate()).padStart(2, "0")}`;
};

// Vencimentos que serão criados (só na criação; editar mexe numa despesa só).
export function vencimentos(f) {
  if (!f.dueDate) return [];
  if (f.isRecurring) {
    const n = Math.min(Math.max(parseInt(f.recurringCount, 10) || 0, 0), 60);
    const passo = (i) => (f.recurringPeriod === "weekly" ? { dias: 7 * i } : f.recurringPeriod === "yearly" ? { anos: i } : { meses: i });
    return Array.from({ length: n }, (_, i) => somar(f.dueDate, passo(i)));
  }
  const parcelas = parseInt(f.installments, 10) || 0;
  if (parcelas > 1) return Array.from({ length: parcelas }, (_, i) => somar(f.dueDate, { meses: i }));
  return [f.dueDate];
}
